<template>
  <div class="pa-4">
    <ExternalAccess class="mb-6" />
    <!-- Table -->
    <v-card color="card" class="elevation-2 rounded-lg">
      <v-card-text class="pa-0">
        <v-data-table
          :headers="resourcesHeaders"
          :items="contracts"
          hide-default-footer
          :page.sync="page"
          class="elevation-1"
          :sort-by="['noContract']"
          :sort-desc="[true]"
          :no-data-text="getLabel('table_no_data')"
          :items-per-page="itemsPerPage"
        >
          <template #[`item.contractStartDate`]="{ item }">
            {{ item.contractStartDate }}
          </template>

          <template #[`item.contractEndDate`]="{ item }">
            {{ item.contractEndDate }}
          </template>
        </v-data-table>
        <v-container>
          <v-row justify="center">
            <v-col cols="6">
              <v-container class="max-width">
                <v-pagination v-if="totalPages != -1" v-model="page" :length="totalPages" />
              </v-container>
            </v-col>
          </v-row>
        </v-container>
        <v-divider />
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { ref, computed } from '@vue/composition-api';

import { useMainStore } from '../../store/index';
import { getLabel, getWorkspaceLabel, getResourceTypeLabel } from '@/utils';

import ExternalAccess from '@/components/profile/ExternalAccess.vue';

export default {
  components: { ExternalAccess },
  setup () {
    const store = useMainStore();

    const resourcesHeaders = [
      {
        text: getLabel('contract_id'),
        value: 'noContract',
        align: 'center'
      },
      {
        text: getLabel('contract_type'),
        value: 'contractType',
        align: 'center'
      },
      {
        text: getLabel('company'),
        value: 'company',
        align: 'center',
        sortable: false
      },
      {
        text: getLabel('establishment'),
        value: 'establishmentName',
        align: 'center',
        sortable: false
      },
      {
        text: getLabel('code_establishment'),
        value: 'buildingCode',
        align: 'center',
        sortable: false
      },
      {
        text: getLabel('job'),
        value: 'job',
        align: 'center',
        sortable: false
      },
      {
        text: getLabel('date_start'),
        value: 'contractStartDate',
        align: 'center'
      },
      {
        text: getLabel('date_end'),
        value: 'contractEndDate',
        align: 'center'
      }
    ];

    const contracts = ref(store.collaborator.contracts && store.collaborator.contracts.length ? store.collaborator.contracts : []);

    const itemsPerPage = 10;

    const page = 1;

    const totalPages = computed(() => (contracts.value.length > 0 ? Math.ceil(contracts.value.length / itemsPerPage) : -1));

    return {
      getLabel,
      getWorkspaceLabel,
      getResourceTypeLabel,
      itemsPerPage,
      page,
      totalPages,
      resourcesHeaders,
      contracts
    };
  }
};
</script>

<style>
</style>
